import API_CALL from '../API';
import { OperationSpec } from '../transactions/models/OperationContext';
import { RequestOptions, prepareRequestOptions } from './RequestHelpers';

export const RequestService = {
  async makeRequest<T>(
    options: OperationSpec,
    extraRequestOptions?: Partial<RequestOptions> | undefined,
    signal?: AbortSignal
  ): Promise<T> {
    const requestOptions: RequestOptions = await prepareRequestOptions(
      options,
      extraRequestOptions
    );
    const operationId = options.operationId;

    return API_CALL({
      url: `/request/${operationId}`,
      method: 'POST',
      data: requestOptions,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      signal: signal,
    }).then((data: T) => {
      return {
        ...data,
        operationId,
        requestOptions,
      } as T;
    });
  },
};
